import React, { useEffect, useState, useContext } from "react";
import { useForm } from "react-hook-form";
import "../ContentPages/style.css";
import "../ContentPages/identityimagestyle.css";
import CustomEditButton from "../Buttons/CustomEditButton";
import BrandedInfo from "../../assets/images/BrandedInfo.svg";
import BackIconWhite from "../../assets/images/BackIconWhite.svg";

import CancelIcon from "../../assets/images/Cancel.svg";
import LoadImageIcon from "../../assets/images/LoadImage.svg";
import { AppContext } from "../../contexts/AppContext";
import {
  getCountryNameById,
  getLabelFromId,
} from "../../Services/localStorage.tsx";
import { useNavigate } from "react-router-dom";

import CancelIdentity from "../Popups/CancelIdentity";
import { calculateAge } from "../../Services/localStorage.tsx";
import {
  initiateApplication,
  submitApplication,
} from "../../Services/applicationService.jsx";
import { AlreadySubmittedError } from "../../Utils/Errors.tsx";
import Loader from "../Loader/Loader";
import { getImage } from "../../Services/applicationService.jsx";
import { redirectToRealMe } from "../../Services/apiService.jsx";
import SubmitButton from "../Buttons/SubmitButton.jsx";
import FieldError from "../FieldError/index.jsx";
import ExternalLink from "../ExternalLink/ExternalLink.tsx";

const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const options = { day: "2-digit", month: "long", year: "numeric" };
  return date.toLocaleDateString("en-NZ", options); // Example: 27 April 1948
};

const MyIdentity = ({ handleNext, handleBack }) => {
  const {
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [identityData, setIdentityData] = useState({});
  const [identityImage, setIdentityImage] = useState(null);
  const [imageError, setImageError] = useState(null);
  const [showImage, setShowImage] = useState(false);
  const { appState, setAppState, userFlows, setUserFlows, userRegister } =
    useContext(AppContext);
  const [showCancelIdentity, setShowCancelIdentity] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const showCancelIdentityPopup = () => {
    setShowCancelIdentity(true);
  };

  const handleCancelIdentity = () => {
    setLoading(true);

    const age = calculateAge(appState.requestPayload.applicant.dateOfBirth);
    let applicationId = "dee0075c-6dcd-ef11-b8e9-00224891c497";
    if (age < 14) {
      applicationId = "fee0075c-6dcd-ef11-b8e9-00224891c497";
      setUserFlows({
        ...userFlows,
        showLiveness: false,
        childApplication: true,
      });
    }

    let updatedAppState = {
      ...appState,
      requestPayload: {
        applicationFlowCode: 100000005,
        applicationTypeId: applicationId,
        ...appState.requestPayload,
      },
    };

    initiateApplication(updatedAppState.requestPayload)
      .then((response) => {
        console.log("Application initiated successfully:", response);
        updatedAppState = {
          ...updatedAppState,
          requestPayload: {
            ...updatedAppState.requestPayload,
            serviceId: response.serviceId,
          },
        };
        console.log("Updated App State: ", updatedAppState);
        submitApplication(updatedAppState.requestPayload)
          .then((response) => {
            console.log("Application submitted successfully:", response);
            setLoading(false);
            setAppState(updatedAppState);
            setUserFlows({
              ...userFlows,
              isCancelRequested: true,
            });
            navigate("/app/cancel-identity");
          })
          .catch((error) => {
            setLoading(false);
            if (!(error instanceof AlreadySubmittedError)) {
              navigate("/app/something-went-wrong");
            }
          });
      })
      .catch((error) => {
        console.error("Error initiating application:", error);
        setLoading(false);
        navigate("/app/something-went-wrong");
      });

    console.log("Updated App State: ", updatedAppState);

    return;
  };

  const handleViewSharedInfo = () => {
    navigate("/app/my-shared-info");
    return;
  };

  const handleUpdateIdentity = () => {
    navigate("/app/request-change-identity");
    return;
  };

  useEffect(() => {
    setLoading(true);
    console.log(userFlows);
    const fetchData = async () => {
      // Mocked identity details
      console.log(appState.requestPayload.applicant.countryOfBirthId);
      const country = await getCountryNameById(
        appState.requestPayload.applicant.countryOfBirthId || ""
      );
      const gender = await getLabelFromId(
        "GenderReference",
        appState.requestPayload.applicant.genderId || ""
      );
      console.log("userflows", userFlows);
      const resp = {
        fullName:
          appState.requestPayload.applicant.givenNames +
          " " +
          appState.requestPayload.applicant.familyName,
        dob: appState.requestPayload.applicant.dateOfBirth,
        placeOfBirth:
          appState.requestPayload.applicant.placeOfBirth + ", " + country,
        gender: gender,
        status: "Active",
        expiryDate: userFlows?.dateOfExpiry || "",
      };

      setIdentityData(resp);
      setLoading(false);
    };

    const fetchImage = async () => {
      // Mocked image URL

      getImage()
        .then((image) => {
          console.log("Image fetched successfully:", image);
          setIdentityImage(image.photo);
        })
        .catch((error) => {
          console.error("Error fetching image:", error);
          setImageError(
            "We cannot display your details due to a technical issue. Please try again later."
          );
          //navigate("/app/something-went-wrong");
        });
      // setIdentityImage("https://example.com/identity-image.jpg");
    };

    fetchData();
    fetchImage();
  }, []);

  const onSubmit = (data) => {
    console.log(data);
    handleNext();
  };

  // if (!identityData) return <Loader />;

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro1">
          <h1 className="intro-title-mi" lang="mi-NZ">
            Aku taipitopito tuakiri hāpono
          </h1>
          <hr />
          <h1 className="intro-title">My verified identity details</h1>
          {loading && <Loader />}
          <div className="container">
            <div className="row">
              <p className="note">
                {userFlows.isChangeRequested ? (
                  <FieldError
                    error={null}
                    info="We've got your request to update your identity details. We'll contact you once your details have been updated, or if we need any more information."
                    InfoStyle={{ maxWidth: 900 }}
                  />
                ) : (
                  <React.Fragment>
                    If your name or gender has changed, you can update it
                    online. To correct any other details,{" "}
                    <ExternalLink
                      href="https://www.realme.govt.nz/contact-us/"
                      text="contact us."
                    />
                  </React.Fragment>
                )}
              </p>
            </div>
            <div className="row">
              <div className="step-container1">
                <div className="row step-container-details1">
                  <div className="step-container-box dob-box">
                    <p className="label">Full name</p>
                    <p className="value">{identityData.fullName}</p>
                    {userRegister?.personName?.nameInDispute && (
                      <span
                        className="inline-badge dob-badge"
                        aria-label="Derived"
                      >
                        D<span className="dob-tooltip">Disputed attribute</span>
                      </span>
                    )}
                  </div>
                  <div className="step-container-box dob-box">
                    <p className="label">Date of birth</p>
                    <p className="value">{formatDate(identityData.dob)}</p>
                    {userRegister?.dateOfBirthInDispute && (
                      <span
                        className="inline-badge dob-badge"
                        aria-label="Derived"
                      >
                        D<span className="dob-tooltip">Disputed attribute</span>
                      </span>
                    )}
                  </div>
                  <div className="step-container-box dob-box">
                    <p className="label">Place of birth</p>
                    <p className="value">{identityData.placeOfBirth}</p>
                    {(userRegister?.countryOfBirthInDispute ||
                      userRegister?.placeOfBirthInDispute) && (
                      <span
                        className="inline-badge dob-badge"
                        aria-label="Derived"
                      >
                        D<span className="dob-tooltip">Disputed attribute</span>
                      </span>
                    )}
                  </div>
                  <div className="step-container-box dob-box">
                    <p className="label">Gender</p>
                    <p className="value">{identityData.gender}</p>
                    {userRegister?.genderInDispute && (
                      <span
                        className="inline-badge dob-badge"
                        aria-label="Derived"
                      >
                        D<span className="dob-tooltip">Disputed attribute</span>
                      </span>
                    )}
                  </div>
                  <div className="step-container-box">
                    <p className="label">Status</p>
                    <p className="value">{identityData.status}</p>
                  </div>
                  <div className="step-container-box">
                    <p className="label">Expiry date</p>
                    <p className="value">
                      {formatDate(identityData.expiryDate)}
                    </p>
                  </div>

                  <label className="terms-label" htmlFor="terms-checkbox">
                    You must renew your verified identity every 10 years.
                  </label>
                  <div className="step-container-nospace">
                    {!userFlows.isChangeRequested && (
                      <CustomEditButton
                        text={"Update my name or gender"}
                        onClick={handleUpdateIdentity}
                        type="button"
                      />
                    )}
                    <CustomEditButton
                      text={"View shared information"}
                      onClick={handleViewSharedInfo}
                      type="button"
                      icon={BrandedInfo}
                    />
                    {!userFlows.isCancelRequested && (
                      <CustomEditButton
                        text={"Cancel my verified identity"}
                        onClick={showCancelIdentityPopup}
                        type="button"
                        icon={CancelIcon}
                      />
                    )}
                    <SubmitButton
                      text={"Back to RealMe"}
                      Icon={BackIconWhite}
                      onClick={redirectToRealMe}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="image-container1">
                    {!showImage && (
                      <center>
                        <CustomEditButton
                          icon={LoadImageIcon}
                          text={"View Image"}
                          type="button"
                          onClick={() => setShowImage((prev) => !prev)}
                        />
                      </center>
                    )}
                    {showImage && identityImage && (
                      <div style={{ marginTop: "1rem", textAlign: "center" }}>
                        <img
                          src={`data:image/jpeg;base64,${identityImage}`}
                          alt="Identity"
                          style={{ maxWidth: "250px", borderRadius: "8px" }}
                        />
                      </div>
                    )}
                  </div>
                  {showImage && imageError && (
                    <FieldError error={{ message: imageError }} info={null} />
                  )}

                  <div className="image-container-text1">
                    <h2 className="step-title mb-2">Your identity image</h2>
                    <p>
                      This image was captured during your application. Check our
                      terms of use for how we'll use this image.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      {showCancelIdentity && (
        <CancelIdentity
          isOpen={showCancelIdentity}
          onClose={() => setShowCancelIdentity(false)}
          onContinue={handleCancelIdentity}
        />
      )}
    </>
  );
};

export default MyIdentity;
